import { Link } from 'react-router-dom';
import logoYoyonHeader from '@/assets/logo-yonyon-header-300x100.png'

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-100 mt-8">
      <div className="px-4 md:px-8 py-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <img
                src={logoYoyonHeader}
                alt="Yonyon"
                className="h-16 w-[6.5rem] bg-white object-cover"
              />
            </div>
            <p className="mt-3 text-sm text-primary-200/80 leading-relaxed max-w-xs">
              Le réseau d'activités, d'entraide et de conversations de proximité du Grand Dole.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">Découvrir</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-primary-200/80 hover:text-white transition-colors cursor-pointer">
                  Activités
                </Link>
              </li>
              {/* 
                    ======== desactivé temporairement
              <li>
                <Link to="/le-coin" className="text-primary-200/80 hover:text-white transition-colors cursor-pointer">
                  Le Coin
                </Link>
              </li> */}

              <li>
                <Link to="/" className="text-primary-200/80 hover:text-white transition-colors cursor-pointer">
                  S'entraider
                </Link>
              </li>

              <li>
                <Link
                  to="/"
                  state={{ expandMap: true }}
                  className="text-primary-200/80 hover:text-white transition-colors cursor-pointer"
                >
                  Carte
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">À propos</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/notre-mission" className="text-primary-200/80 hover:text-white transition-colors cursor-pointer">
                  Notre mission
                </Link>
              </li>
              <li>
                <Link to="/regles-communaute" className="text-primary-200/80 hover:text-white transition-colors cursor-pointer">
                  Règles et mentions légales
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-200/80 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="px-4 md:px-8 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-primary-200/70">
            <span>© 2026 Yonyon · Fait à Dole</span>
            <span>Sortir · Bouger · S'entraider · Papoter</span>
          </div>
        </div>
      </div>
    </footer>
  );
}